import type { PagedResultDto } from "@services/dto/pagedResultDto"
import { action, makeAutoObservable, observable } from "mobx"
import configurationPaymentService from "@services/configurationPayment/configurationPayment"

class ConfigurationPaymentStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable listPaymentSchedule!: any
  @observable dataConfigurationPayment!: any
  constructor() {
    makeAutoObservable(this)

    this.tableData = { items: [], totalCount: 0 }
    this.detailData = {}
    this.listPaymentSchedule = []
  }

  @action
  async create(body: any) {
    await configurationPaymentService.create(body)
  }

  async update(body: any) {
    await configurationPaymentService.update(body)
  }

  @action
  async active(id: number, isActive) {
    await configurationPaymentService.active(id, isActive)
  }
  @action
  async emptyDetail() {
    this.detailData = {}
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await configurationPaymentService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await configurationPaymentService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async getList(params?: any) {
    this.isLoading = true
    const result = await configurationPaymentService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.listPaymentSchedule = result
  }

  @action
  async calculateConfigurationPayment(body: any) {
    this.isLoading = true
    const result = await configurationPaymentService
      .calculateConfigurationPayment(body)
      .finally(() => (this.isLoading = false))
    this.dataConfigurationPayment = result
  }

  @action
  async resetDataConfigurationPayment() {
    this.dataConfigurationPayment = null
  }

  @action
  async validateBeforeImport(file: File) {
    this.isLoading = true
    const result = await configurationPaymentService
      .validateBeforeImport(file)
      .finally(() => (this.isLoading = false))
    return result
  }

  @action
  async importConfigurationPayment(file: File) {
    this.isLoading = true
    await configurationPaymentService
      .importConfigurationPayment(file)
      .finally(() => (this.isLoading = false))
  }

  @action
  async downloadImportTemplate() {
    await configurationPaymentService.downloadImportTemplate()
  }
}

export default ConfigurationPaymentStore
